import { useEffect, useState } from "react";
// import Header from "./Header";
import MainContainer from "../../components/MainContainer";
import ProductVariants from "../EditProductDetails/ProductVariants";
import ProductDetails from "../EditProductDetails/ProductDetails";

import productImg from "../../assets/product.png";
import ProductColors from "./ProductColors";
import SetPricingRule from "./SetPricingRule";
import {
  getCustomizedProduct,
  getCustomizedProductTable,
} from "../../api/catalog_product.api";

import Designer from "../../designer";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../hooks/reduxHooks";
import Header from "../../components/Header_new";

const StartDesigning = () => {
  // const urlParams = new URLSearchParams(window.location.search);

  const { productId } = useParams();
  var customizeProductId = { productId }.productId;

  const [step, setStep] = useState(2);
  const [customizeTableData, setCustomizeTableData] = useState({
    title: "",
    productImg: "",
  });

  const [productOption, setProductOption] = useState<[]>([]);
  const [colors, setColors] = useState<any>([]);
  const [sizes, setSizes] = useState<any>([]);
  const [productVariant, setproductVariant] = useState<any>([]);
  const [varinatImages, setVarinatImages] = useState<any>([
    { id: 1, src: productImg },
  ]);
  const [checkedVariants, setCheckedVariants] = useState<any>([]);
  const [customizeProductIdd, setCustomizeProductIdd] =
    useState<any>(customizeProductId);
  const [pricingData, setPricingData] = useState<any>([]);
  const viewData = useAppSelector(
    (state: any) => state.canvases.original_view_data
  );

  const [selectedOptionArray, setSelectedOptionArray] = useState<any>([]);

  const [tags, setTags] = useState<any>([]);
  const [collections, setCollections] = useState<any>([]);

  const handleChangeTitle = (e: any) => {
    setCustomizeTableData((prev) => ({
      ...prev,
      ["title"]: e.target.value,
    }));
    // console.log("____titleChange", customizeTableData);
  };

  const handleChangeDescription = (e: any) => {
    setCustomizeTableData((prev) => ({
      ...prev,
      ["body_html"]: e.target.value,
    }));
    // console.log("____titleChange", customizeTableData);
  };

  useEffect(() => {
    let stringWithimages = checkedVariants
      .map((item: any) => `${item}`)
      .join(", ");
    setCustomizeTableData((prev) => ({
      ...prev,
      ["selected_images"]: stringWithimages,
    }));
    // console.log("checkeddd", customizeTableData);
  }, [checkedVariants]);

  const callFunction = async () => {
    let cust_data_detail_table = await getCustomizedProductTable(
      customizeProductId
    );
    let cust_data_detail = await getCustomizedProduct(customizeProductId);

    //TODO: API missing POdProductsVariants field like we have in My Products -> Edit

    console.log(
      "cust_data_detail_____",
      cust_data_detail_table,
      cust_data_detail
    );
    if (cust_data_detail_table.data) {
      setCustomizeTableData(cust_data_detail_table.data);
    }
    // setVarinatImages(cust_data_detail.data.customize_data.catalogproductimages);
    setVarinatImages(cust_data_detail.data.selected_images);

    setproductVariant(
      cust_data_detail.data.customize_data.catalogproductvariants
    );
    setColors(cust_data_detail.data.customize_data.catalogproductvariants);

    let options = cust_data_detail.data.customize_data.catalogproductoptions;
    setProductOption(options);
    if (cust_data_detail.data.productPrice) {
      setPricingData(cust_data_detail.data.productPrice);
    }
    setCustomizeTableData((prev) => ({
      ...prev,
      ["selected_images"]: "",
    }));
  };

  useEffect(() => {
    callFunction();
  }, []);

  useEffect(() => {
    let optionArray: any = [];
    if (colors.length > 0) {
      let stringColors = colors.map((item: any) => `${item}`).join(",");
      optionArray.push({
        PodProductId: customizeProductId,
        option: "Color",
        value: stringColors,
      });
      // console.log("selected option colors::", colors);
    }
    if (sizes.length > 0) {
      let stringSize = sizes.map((item: any) => `${item}`).join(",");
      optionArray.push({
        PodProductId: customizeProductId,
        option: "Size",
        value: stringSize,
      });
      // console.log("selected option sizes::", sizes);
    }

    // console.log("optionArray____", optionArray);
    setSelectedOptionArray(optionArray);
  }, [colors, sizes]);

  useEffect(() => {
    if (tags.length > 0) {
      let stringTags = tags.map((item: any) => `${item}`).join(",");
      setCustomizeTableData((prev) => ({
        ...prev,
        ["product_tag"]: stringTags,
      }));
    }

    if (collections.length > 0) {
      let stringcoll = collections.map((item: any) => `${item}`).join(",");
      setCustomizeTableData((prev) => ({
        ...prev,
        ["product_collection"]: stringcoll,
      }));
    }
  }, [tags, collections]);

  useEffect(() => {
    // console.log("pricingData________", pricingData);
  }, [pricingData]);

  return (
    <>
      {" "}
      <div className="absolute z-[9999] left-0 right-0 top-0 bottom-0 w-screen h-max min-h-screen bg-gray-100 ">
        {/* <Header
          step={step}
          setStep={setStep}
          productId={customizeProductIdd}
          customizeTableData={customizeTableData}
          selectedOptionArray={selectedOptionArray}
        /> */}
        <Header></Header>

        <div
          className="mt-2"
          style={{ display: step === 2 ? "block" : "none" }}
        >
          <>
            {!viewData || viewData.length === 0 ? (
              <div className="text-center z-[9999] h-[100vh] absolute bg-[#ffffff42] w-[100%]">
                <div role="status" className="absolute left-[50%] top-[40%]">
                  <svg
                    aria-hidden="true"
                    className="inline w-20 h-20 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              ""
            )}{" "}
            <Designer></Designer>
          </>
        </div>

        {step === 3 && (
          <MainContainer className="max-w-[1200px]">
            <h2>Edit Product Details & Choose Options</h2>
            <br />
            <ProductDetails
              customizeTableData={customizeTableData}
              handleChangeTitle={handleChangeTitle}
              handleChangeDescription={handleChangeDescription}
              tags={tags}
              setTags={setTags}
              collections={collections}
              setCollections={setCollections}
            />
            <ProductColors product={colors} previews={varinatImages} />
            {/* <ChoosePrintMethods productMock={productMock} />
          <EditPrintLocations productMock={productMock} /> */}
          </MainContainer>
        )}

        {step === 4 && (
          <MainContainer className="max-w-[1200px]">
            <h2>Set Pricing Rules</h2>
            <br />
            <SetPricingRule
              pricingData={pricingData}
              setPricingData={setPricingData}
            />
            {/* <SetShippingModel productMock={productMock} /> */}
          </MainContainer>
        )}

        {step === 5 && (
          <MainContainer className="max-w-[1200px]">
            <h2>Choose your Product Mockups</h2>
            <br />
            <ProductVariants
              varinatImages={varinatImages}
              setVarinatImages={setVarinatImages}
              checkedVariants={checkedVariants}
              setCheckedVariants={setCheckedVariants}
            />
          </MainContainer>
        )}
      </div>
    </>
  );
};

export default StartDesigning;
